import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { injectIntl } from 'react-intl'
import { type TimeRange, type ChartSeries } from 'legacy/components/DataViz/dataViz.types'
import { generateFooterLabel } from 'legacy/components/DataViz/Charts/ChartFooter/utils'
import { type InjectedIntlProps } from 'intl/intl.types'

const ChartFooterContainer = styled.div`
  display: flex;
`

export interface ChartFooterProps extends InjectedIntlProps {
  chartSeries: ChartSeries[]
  timeRange: TimeRange
}

const ChartFooter: FunctionComponent<ChartFooterProps> = ({ intl, chartSeries, timeRange }) => {
  return (
    <ChartFooterContainer>
      {chartSeries.map(generateFooterLabel({ intl, timeRange }))}
    </ChartFooterContainer>
  )
}

export default injectIntl(ChartFooter)
